export enum OfferType {
  Selling = 0,
  Buying = 1,
  Other = 2,
  Own = 3,
}

export enum PropertyTypeNumber {
  Apartment,
  House,
}

export enum AnswerQuestion {
  NO,
  YES,
}

export enum WhenToSell {
  Now = 0,
  Within6Month = 1,
  Within2Year = 2,
  Later = 3,
}
